<template>
  <div class="shopping-cart-item p-b-20 m-t-20">
    <cart-list-item :product="product" />
    <span v-if="!product.active" class="shopping-cart-item__status shopping-cart-item__status_disabled p-10">
      Item is no longer available
    </span>
    <span v-if="!product.valid" class="shopping-cart-item__status shopping-cart-item__status_invalid p-10">
      Please review, this item needs your attention
    </span>
    <div v-if="!readOnly" class="shopping-cart-item__links-container">
      <button
        v-if="product.active"
        :aria-label="`Edit ${product.item.name}`"
        class="shopping-cart-item__link p-l-20 m-r-65 iw-hyperlink"
        @click="openModal"
      >
        Edit
      </button>
      <button
        class="shopping-cart-item__link iw-hyperlink"
        :aria-label="`Remove ${product.item.name}`"
        @click="removeCartItem(index)"
      >
        Remove
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VendorMenuModal from "../../../../components/modal/vendor-menu-modal/VendorMenuModal";
import CartListItem from "./cart-list-item/CartListItem";

export default {
  name: "ShoppingCartItem",
  components: { CartListItem },
  props: {
    product: Object,
    index: Number,
    readOnly: Boolean
  },
  data() {
    return {
      NUMBER_AFTER_COMMA: 2
    };
  },
  computed: {
    ...mapGetters({
      hasDiscount: "cart/hasDiscount",
      activeVendor: "vendor/getActiveVendor"
    })
  },
  methods: {
    ...mapActions({
      removeItem: "cart/removeItemFromShoppingCart",
      clearDiscount: "cart/clearDiscount",
      detectClosedVendors: "vendor/detectClosedVendors"
    }),
    openModal() {
      this.detectClosedVendors([this.activeVendor]);
      this.$modal.show(
        VendorMenuModal,
        {
          menuItem: this.product.item,
          instructions: this.product.specialInstructions,
          quantity: this.product.quantity,
          isEdit: true,
          index: this.index
        },
        {
          name: "item",
          height: "auto",
          width: 500,
          adaptive: true,
          scrollable: true
        }
      );
    },
    removeCartItem(index) {
      this.removeItem({ index });
    }
  }
};
</script>

<style scoped lang="scss">
.dark {
  .shopping-cart-item {
    &__status {
      &_disabled {
        color: $primary-color;
        background-color: rgba($error-color, 0.5);
      }

      &_invalid {
        background-color: rgba($border-color, 0.1);
      }
    }
  }
}

.shopping-cart-item {
  display: flex;
  flex-direction: column;
  border-bottom: 0.8px solid $group-3-color-2-alpha-30;

  &:last-child {
    border-bottom: none;
  }

  &__links-container {
    margin-top: 12px;
    margin-left: 46px;
    & > button {
      border: none;
      background: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
    @include respond-to-mobile {
      margin-left: 36px;
    }
  }

  &__status {
    align-self: flex-start;
    text-transform: uppercase;
    text-align: center;
    font-weight: $font_bold;
    border-radius: 3px;

    &_disabled {
      color: $notifier-failed-text;
      background-color: $notifier-failed-background;
    }

    &_invalid {
      background-color: $border-color;
    }
  }
}
</style>
